import formatPrice from '../helpers/formatPrice';

const $cart = $('.js-cart');
const $total = $('.js-cart-total');
const $tax = $('.js-cart-tax');
const $subTotal = $('.js-cart-subtotal');
const $shippingCosts = $('.js-shipping-costs');
const $freeGift = $('.js-free-gift');
const $credits = $('.js-cart-credits');

const ROW_SELECTOR = '.js-cart-item';
const ROW_TOTAL_SELECTOR = '.js-cart-item-total';
const ROW_QUANTITY_SELECTOR = '.js-cart-item-quantity';
const ROW_DELETE_SELECTOR = '.js-cart-item-delete';
const ROW_CREDITS_SELECTOR = '.js-cart-item-credits-amount';

const SHIPPING_COSTS_PROGRESS_ELEMENT = '.js-shipping-costs-progress';
const SHIPPING_COSTS_PROGRESS_CONTENT = '.js-shipping-costs-progress-content';
const SHIPPING_COSTS_PROGRESS_BAR_CONTAINER = '.js-shipping-costs-progress-bar-container';
const SHIPPING_COSTS_PROGRESS_BAR = '.js-shipping-costs-progress-bar';
const SHIPPING_COSTS_PROGRESS_REMAINING = '.js-shipping-costs-progress-remaining';
const SHIPPING_COSTS_PROGRESS_REMAINING_PERCENTAGE = '.js-shipping-costs-progress-remaining-percentage';

const COUPON_WRAPPER = '.js-coupon';
const CUSTOMER_DISCOUNT_WRAPPER = '.js-customer-discount';

export default {
  initialize() {
    if ($cart.length) {
      this.createListeners();
      this.getItems = () => { this.items = $(ROW_SELECTOR).toArray(); };
      this.getItems();
      this.recalculateTotals();
    }
  },

  createListeners() {
    $cart.on('change', ROW_QUANTITY_SELECTOR, this.handleQuantityChange.bind(this));
    $cart.on('click', ROW_DELETE_SELECTOR, this.handleItemDelete.bind(this));

    $cart.on('recalculate', () => {
      this.recalculateTotals();
    });
  },

  handleQuantityChange(e) {
    const $input = $(e.currentTarget);
    const $row = this.getCartRow($input);
    const quantity = parseInt($input.val(), 10);
    const cartItemId = this.getCartItemId(this.retrieveCartItem($input));

    if (Number.isNaN(quantity)) {
      return;
    }

    this.recalculateRow($row);
    this.recalculateTotals();
    this.updateCartItem(cartItemId, quantity);
  },

  handleItemDelete(e) {
    e.preventDefault();

    const $button = $(e.currentTarget);
    const $cartItem = this.retrieveCartItem($button);
    const cartItemId = this.getCartItemId($cartItem);

    this.deleteCartItem(cartItemId)
      .then(() => {
        $cartItem.remove();
        $cart.trigger('recalculate');
      });
  },

  /**
   * @param {object} $el
   * @returns {object}
   */
  retrieveCartItem($el) {
    return $el.parents('.js-cart-item');
  },

  /**
   * @param {object} $row
   * @returns {int}
   */
  getCartItemId($row) {
    return parseInt($row.data('id'), 10);
  },

  /**
   * Retrieve the parent cart row for given element
   * @param {Object} $el jQuery element
   * @return {Object} Cart row
   */
  getCartRow($el) {
    return $el.parents(ROW_SELECTOR);
  },

  /**
   * Get price per piece for the row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getPriceForRow($row, fallback = 0) {
    const val = parseFloat($row.data('price'));
    return (Number.isNaN(val)) ? fallback : val;
  },

  /**
   * Get tax per piece for the row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getTaxForRow($row, fallback = 0) {
    const val = parseFloat($row.data('tax'));
    return (Number.isNaN(val)) ? fallback : val;
  },

  /**
   * Get credits per piece for the row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getCreditsForRow($row, fallback = 0) {
    const val = parseFloat($row.data('credits'));
    return (Number.isNaN(val)) ? fallback : val;
  },

  /**
   * Get price without tax per piece for the row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getPriceWithoutTaxForRow($row, fallback = 0) {
    const val = parseFloat($row.data('price-without-tax'));
    return (Number.isNaN(val)) ? fallback : val;
  },

  /**
   * Get quantity of the product row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getQuantityForRow($row, fallback = 1) {
    const val = parseInt($row.find(ROW_QUANTITY_SELECTOR).val(), 10);
    return (Number.isNaN(val)) ? fallback : val;
  },

  /**
   * Recalculate the total of the product row
   * @param {Object} $row jQuery element of the product row
   * @return {void}
   */
  recalculateRow($row) {
    const price = this.getPriceForRow($row);
    const tax = this.getTaxForRow($row);
    const quantity = this.getQuantityForRow($row);
    const credits = this.getCreditsForRow($row);
    const total = price * quantity;
    const totalTax = tax * quantity;
    const totalCredits = credits * quantity;
    const prevQuantity = parseInt($row.data('quantity'), 10);

    $row.data('quantity', quantity);

    if (typeof $row.data('product') !== 'undefined') {
      const diffQuantity = quantity - prevQuantity;

      if (diffQuantity > 0) {
        this.gtmAdd($row.data('product'), diffQuantity);
      } else if (diffQuantity < 0) {
        this.gtmRemove($row.data('product'), diffQuantity);
      }

      this.cartChange($row.data('id'), quantity);
    }

    this.outputRowTotal($row, total);
    this.outputRowTax($row, totalTax);
    this.outputRowCredits($row, totalCredits);
  },

  /**
   * Output the total price for the row
   * @param {Object} $row jQuery element of the product row
   * @param {Number} total Total price
   * @return {void}
   */
  outputRowTotal($row, total) {
    $row
      .data('total', total)
      .find(ROW_TOTAL_SELECTOR)
      .html(formatPrice(total));
  },

  /**
   * Output the total tax for the row
   * @param {Object} $row jQuery element of the product row
   * @param {Number} total Total price
   * @return {void}
   */
  outputRowTax($row, total) {
    $row.data('total-tax', total);
  },

  /**
   * Output the total credits for the row
   * @param {Object} $row jQuery element of the product row
   * @param {Number} total Total credits
   * @return {void}
   */
  outputRowCredits($row, total) {
    $row
      .data('total-credits', total)
      .find(ROW_CREDITS_SELECTOR)
      .text(total);
  },

  /**
   * Calculate the cart total and output
   * @return {void}
   */
  recalculateTotals() {
    this.getItems();

    const total = this.items.reduce((acc, item) => (
      acc + parseFloat($(item).data('total'))
    ), 0);

    const tax = this.items.reduce((acc, item) => (
      acc + parseFloat($(item).data('total-tax'))
    ), 0);

    const totalCredits = this.items.reduce((acc, item) => (
      acc + parseFloat($(item).data('total-credits'))
    ), 0);

    const couponValue = parseFloat($cart.find(COUPON_WRAPPER).data('value'));
    let discountValue = parseFloat($cart.find(CUSTOMER_DISCOUNT_WRAPPER).data('value'));

    // eslint-disable-next-line no-restricted-globals
    if (isNaN(discountValue)) {
      discountValue = 0;
    }

    const ensurePositive = val => (val < 0 ? 0 : val);

    if (total < $shippingCosts.data('minimum-price-for-shipping')) {
      $total.html(formatPrice(ensurePositive((total + $shippingCosts.data('shipping-costs')) - couponValue - discountValue)));
    } else {
      $total.html(formatPrice(ensurePositive(total - couponValue - discountValue)));
    }

    $subTotal.html(formatPrice(ensurePositive(total - tax)));
    $tax.html(formatPrice(tax));
    $credits.html(parseInt(totalCredits, 10));

    this.updateShippingPriceProgressBar(ensurePositive(total - couponValue));
    this.toggleFreeGift(ensurePositive(total));

    $(document).trigger('cart:change', total);
  },

  toggleFreeGift(total) {
    const shouldShow = total >= $freeGift.data('free-gift-from');
    const $freeGiftCheckbox = $freeGift.find('.js-cart-free-gift__checkbox');

    $freeGift.toggle(shouldShow);
    $freeGiftCheckbox.prop('checked', shouldShow);

    $.post(window.app.api.cartUpdate, {
      _method: 'PUT',
      receives_gift: shouldShow ? 1 : 0,
    });

    $freeGiftCheckbox.on('change', ({ currentTarget }) => {
      $.post(window.app.api.cartUpdate, {
        _method: 'PUT',
        receives_gift: currentTarget.checked ? 1 : 0,
      });
    });
  },

  /**
   * @param {int} cartItemId
   * @param {int} quantity
   * @returns {Promise}
   */
  updateCartItem(cartItemId, quantity) {
    return $.post(window.app.api.cartItemUpdate.replace(':id', cartItemId), {
      _method: 'PUT',
      quantity,
    });
  },

  /**
   * @param {int} cartItemId
   * @returns {Promise}
   */
  deleteCartItem(cartItemId) {
    return $.post(window.app.api.cartItemDestroy.replace(':id', cartItemId), {
      _method: 'DELETE',
    });
  },

  updateShippingPriceProgressBar(total) {
    const minimumPriceForFreeShippingCosts = $(SHIPPING_COSTS_PROGRESS_ELEMENT).data('minimum-price');
    const remaining = minimumPriceForFreeShippingCosts - total;
    const remainingPercentage = (total / minimumPriceForFreeShippingCosts) * 100;

    $(SHIPPING_COSTS_PROGRESS_CONTENT).find('.is-finished').toggle(total >= minimumPriceForFreeShippingCosts);
    $(SHIPPING_COSTS_PROGRESS_CONTENT).find('.not-finished').toggle(total <= minimumPriceForFreeShippingCosts);

    $(SHIPPING_COSTS_PROGRESS_BAR_CONTAINER).toggle(total <= minimumPriceForFreeShippingCosts);

    $(SHIPPING_COSTS_PROGRESS_REMAINING).html(formatPrice(remaining < 0 ? 0 : remaining));
    $(SHIPPING_COSTS_PROGRESS_BAR).css('width', `${remainingPercentage > 100 ? 100 : remainingPercentage}%`);
    $(SHIPPING_COSTS_PROGRESS_REMAINING_PERCENTAGE).text(`${remainingPercentage >= 100 ? 100 : remainingPercentage.toFixed()}%`);

    $shippingCosts.html(total >= minimumPriceForFreeShippingCosts ? $shippingCosts.data('free-shipping-costs-text') : formatPrice($shippingCosts.data('shipping-costs')));
  },
};
